import { isDesktop } from '@trello/browser';
import { usesEnglish } from '@trello/locale';
const { Auth } = require('app/scripts/db/auth');

export const isEligibleForExperiment = () => {
  return (
    !isDesktop() &&
    usesEnglish() &&
    Auth.me()?.get('isAaMastered') &&
    Auth.me()?.get('confirmed')
  );
};
